import { BaseSensorWebController } from '../../../base/controller/BaseSensorWebController';
import { BaseSensorWebComponent } from '../../../base/BaseSensorWebComponent';
import { templateAtlassianAuditSensor } from '../view/template';
import { IListenerConfig } from '../../../../../framework/BaseWebComponentController';
import { AtlassianAuditView } from '../view/AtlassianAuditView';
import { AtlassianAuditComponent } from '../component/AtlassianAuditComponent';

export class AtlassianAuditController extends BaseSensorWebController {
  public component: BaseSensorWebComponent;
  public view: AtlassianAuditView;
  public viewConstructor: typeof AtlassianAuditView;

  constructor(component: AtlassianAuditComponent) {
    super(component);
    this.initialSetup({
      viewConstructor: AtlassianAuditView,
      viewTemplate: templateAtlassianAuditSensor,
    });
  }

  public isSensorEnabled(): boolean {
    return true;
  }

  public computeEventListeners(): IListenerConfig[] {
    return super.computeEventListeners().concat([
      {
        element: this.view.dom.$responseActions,
        event: 'change',
        callback: this.responseActionsChanged,
      },
    ]);
  }

  private responseActionsChanged(ev: CustomEvent): void {
    ev.stopPropagation();
    this.view.setErrorInputMessage(!this.view.dom.$responseActions.Input.checked);
  }

  public resetData(): void {
    super.resetData();
    this.view.dom.$organizationId.resetField();
    this.view.dom.$adminApiKey.resetField();
  }
}
